import React, { useState, Component } from 'react';
import * as moment from 'moment';
import { render } from 'react-dom';
import { Button } from '@scuf/common';
const UseDateRange = ({callback: callback}) => {

    const [ranges, setRange] = useState([
    { title: '24H', id: 'D', subtract: -1},
    { title: '7D', id: 'W', subtract: -7 },
    { title: '30D', id: 'M', subtract: -30 },
    ]);

    const [selected, setSelected] = useState(
        { title: 'Día', id: 'D', dateStart: moment(moment().add(-1, 'days')).format('YYYY-MM-DD HH:mm:ss'), dateEnd: moment().format('YYYY-MM-DD HH:mm:ss') }
        );

    const selectedRange = (x) =>{
        
        x.dateStart  = moment(moment().add(x.subtract, 'days')).format('YYYY-MM-DD HH:mm:ss');
        x.dateEnd= moment().format('YYYY-MM-DD HH:mm:ss');
        setSelected(x);
        if(callback){
            callback(x);
        } 
    
    }
    return (
        <div style={{
            margin: '5px auto',
            width: 'min-content'
        }}>
            <Button.Group>
                {
                    ranges.map((x, key) => <Button
                        key={key}
                        className='button-smaller'
                        type={x.id == selected.id ? 'primary' : 'secondary'}
                        onClick={() => selectedRange(x)} content={x.title} />)
                }
            </Button.Group ></div>)
}

export default UseDateRange;